import "./Profile.css";
const Profile = () => {
  return <h1>Welcome from Profile</h1>;
};
export default Profile;
